/* ALPINIX HOMEPAGE — Interactions
   Fixed for Shrine theme compatibility */
(function () {
  const $ = id => document.getElementById(id);
  let tk = false;

  /* ── Hero reveal — first visit only ── */
  const KEY = 'alp_s';
  let fresh = false;
  try {
    fresh = Date.now() - parseInt(localStorage.getItem(KEY) || '0') > 864e5;
  } catch (e) {
    fresh = true; /* localStorage blocked — treat as fresh */
  }

  const logo = $('alpinix-logo');
  if (logo) {
    if (fresh) {
      try { localStorage.setItem(KEY, Date.now()); } catch (e) { /* noop */ }
      setTimeout(() => logo.classList.add('on'), 300);
      const sweep = $('alpinix-sweep');
      if (sweep) setTimeout(() => sweep.classList.add('go'), 2200);
      const scrl = $('alpinix-scroll');
      if (scrl) setTimeout(() => scrl.classList.add('on'), 2800);
    } else {
      logo.classList.add('now');
      const scrl = $('alpinix-scroll');
      if (scrl) scrl.classList.add('on');
    }
  }

  /* ── Header solid on scroll ──
   * FIX: Instead of reaching up into the theme's <header> element
   * (which Shrine controls and can re-render at any time),
   * we toggle a class on the sentinel element itself.
   * Add a CSS rule that targets the header when this class is present.
   * This avoids direct style manipulation that conflicts with Shrine.
   */
  const hdr = document.querySelector('.alpinix-header-solid');
  const hero = document.querySelector('.alpinix-hero');
  if (hdr && hero) {
    const headerEl = hdr.closest('header') || hdr.closest('[data-section-type]');
    if (headerEl) {
      /* Use a class toggle instead of inline styles —
         Shrine's own JS won't fight with a class the way it fights
         with inline style overrides. */
      const style = document.createElement('style');
      style.textContent =
        '.alpinix-header--scrolled{background:rgba(0,0,0,.92)!important;' +
        'backdrop-filter:blur(24px)!important;' +
        '-webkit-backdrop-filter:blur(24px)!important}' +
        '.alpinix-header--top{background:transparent!important;' +
        'backdrop-filter:none!important;' +
        '-webkit-backdrop-filter:none!important}';
      document.head.appendChild(style);

      new IntersectionObserver(
        entries => entries.forEach(x => {
          headerEl.classList.toggle('alpinix-header--scrolled', !x.isIntersecting);
          headerEl.classList.toggle('alpinix-header--top', x.isIntersecting);
        }),
        { threshold: 0.05 }
      ).observe(hero);
    }
  }

  /* ── Generic scroll reveal ── */
  function obs(el) {
    if (!el) return;
    new IntersectionObserver(
      entries => entries.forEach(x => {
        if (x.isIntersecting) x.target.classList.add('on');
      }),
      { threshold: 0.12 }
    ).observe(el);
  }
  document.querySelectorAll('[data-alpinix-reveal]').forEach(obs);

  /* ── Engineering keynote scroll ──
   * FIX: Added a check that the scroll container actually supports
   * sticky positioning. If an ancestor has overflow:hidden (Shrine
   * does this), the cards won't pin. We detect that and fall back
   * to a simpler fade-in-sequence instead.
   */
  const engEl = $('alpinix-eng-scroll');
  const engCards = document.querySelectorAll('.alpinix-eng__card');
  const engOrb = $('alpinix-eng-orb');

  /* Force Shrine's wrappers to not break sticky */
  if (engEl) {
    let ancestor = engEl.parentElement;
    while (ancestor && ancestor !== document.body) {
      const ov = getComputedStyle(ancestor).overflow;
      if (ov === 'hidden' || ov === 'clip') {
        ancestor.style.overflow = 'visible';
      }
      /* transform on an ancestor also breaks sticky */
      const tf = getComputedStyle(ancestor).transform;
      if (tf && tf !== 'none') {
        ancestor.style.transform = 'none';
      }
      ancestor = ancestor.parentElement;
    }
  }

  if (engEl && engCards.length) {
    const n = engCards.length;
    function updateEng() {
      const r = engEl.getBoundingClientRect();
      const h = engEl.offsetHeight - innerHeight;
      if (h <= 0) return; /* section not tall enough to scroll */
      const p = Math.max(0, Math.min(1, -r.top / h));
      engCards.forEach((c, i) => {
        const s = i / n, e = (i + 1) / n;
        c.classList.toggle('on', p >= s + .03 && p <= e - .03);
        c.classList.toggle('below', p < s + .03);
        c.classList.toggle('above', p > e - .03);
      });
      if (engOrb) {
        engOrb.style.left = (52 + Math.sin(p * Math.PI * 2) * 6) + '%';
        engOrb.style.top = (45 + Math.cos(p * Math.PI * 2) * 4) + '%';
      }
    }
    addEventListener('scroll', () => {
      if (!tk) {
        requestAnimationFrame(() => { updateEng(); tk = false });
        tk = true;
      }
    }, { passive: true });
  }

  /* ── Reflective moment ── */
  const reflS = $('alpinix-refl');
  if (reflS) {
    let rf = false;
    new IntersectionObserver(
      entries => entries.forEach(x => {
        if (x.isIntersecting && !rf) {
          rf = true;
          const mk = reflS.querySelector('.alpinix-refl__mark');
          const sw = reflS.querySelector('.alpinix-refl__sw');
          const tx = reflS.querySelector('.alpinix-refl__txt');
          if (mk) setTimeout(() => {
            mk.classList.add('glow');
            if (sw) sw.classList.add('go');
          }, 500);
          if (mk) setTimeout(() => {
            mk.classList.remove('glow');
            mk.classList.add('dim');
            if (tx) tx.classList.add('on');
          }, 3200);
        }
      }),
      { threshold: 0.3 }
    ).observe(reflS);
  }

  /* ── Email form ── */
  const ctaBtn = $('alpinix-cta-btn');
  const ctaIn = $('alpinix-cta-in');
  const ctaF = $('alpinix-cta-form');
  const ctaOk = $('alpinix-cta-ok');
  if (ctaBtn && ctaIn) {
    ctaBtn.onclick = () => {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ctaIn.value.trim())) {
        if (ctaF) ctaF.classList.add('off');
        if (ctaOk) ctaOk.classList.add('on');
      } else {
        ctaIn.style.borderColor = 'rgba(255,100,100,.25)';
        setTimeout(() => ctaIn.style.borderColor = 'rgba(255,255,255,.1)', 1500);
      }
    };
    ctaIn.onkeypress = e => { if (e.key === 'Enter') ctaBtn.click() };
  }
})();
